import BaseService from "./BaseService";
import http from "./HttpService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/request/requests";
const apiReadyForPickupEndpoint =
	API_BASE_URL_ENV() + "/request/readyForPickup";
const apiPayLeaveParkingEndpoint =
	API_BASE_URL_ENV() + "/request/payLeaveParking";

export default class RequestsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	readyForPickup = (id) => {
		return http.put(`${apiReadyForPickupEndpoint}/${id}`);
	};

	payLeaveParking = (id, data) => {
		return http.post(`${apiPayLeaveParkingEndpoint}/${id}`, { ...data });
	};
}
